var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1234_380)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 6.09375C11.7188 4.97487 11.2743 3.90181 10.4831 3.11064C9.69194 2.31947 8.61888 1.875 7.5 1.875C6.38112 1.875 5.30806 2.31947 4.51689 3.11064C3.72572 3.90181 3.28125 4.97487 3.28125 6.09375C3.28125 7.82438 4.66594 10.08 7.5 12.7819C10.3341 10.08 11.7188 7.82438 11.7188 6.09375ZM7.5 14.0625C4.06219 10.9378 2.34375 8.28094 2.34375 6.09375C2.34375 4.72623 2.887 3.41472 3.85398 2.44773C4.82097 1.48075 6.13248 0.9375 7.5 0.9375C8.86752 0.9375 10.179 1.48075 11.146 2.44773C12.113 3.41472 12.6562 4.72623 12.6562 6.09375C12.6562 8.28094 10.9378 10.9378 7.5 14.0625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.5625C7.74864 6.5625 7.9871 6.46373 8.16291 6.28791C8.33873 6.1121 8.4375 5.87364 8.4375 5.625C8.4375 5.37636 8.33873 5.1379 8.16291 4.96209C7.9871 4.78627 7.74864 4.6875 7.5 4.6875C7.25136 4.6875 7.0129 4.78627 6.83709 4.96209C6.66127 5.1379 6.5625 5.37636 6.5625 5.625C6.5625 5.87364 6.66127 6.1121 6.83709 6.28791C7.0129 6.46373 7.25136 6.5625 7.5 6.5625ZM7.5 7.5C7.00272 7.5 6.52581 7.30246 6.17417 6.95083C5.82254 6.59919 5.625 6.12228 5.625 5.625C5.625 5.12772 5.82254 4.65081 6.17417 4.29917C6.52581 3.94754 7.00272 3.75 7.5 3.75C7.99728 3.75 8.47419 3.94754 8.82582 4.29917C9.17746 4.65081 9.375 5.12772 9.375 5.625C9.375 6.12228 9.17746 6.59919 8.82582 6.95083C8.47419 7.30246 7.99728 7.5 7.5 7.5ZM12.5625 10.3125L14.0625 14.0625H9.84375V13.125H5.15625V14.0625H0.9375L2.4375 10.3125H12.5625ZM11.5528 10.3125H3.44719L2.32219 13.125H12.6778L11.5528 10.3125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1234_380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation2);
export default __webpack_public_path__ + "static/media/location-2.daa34e85b93e892dcc092387586a6e7b.svg";
export { ForwardRef as ReactComponent };